<template>
  <ModalMergeConflict
    v-if="activeMergeConflict"
    :conflict="activeMergeConflict"
  />
</template>

<script setup lang="ts">
import {
  useMergeConflictHost,
} from '../../composable/use-merge-conflict.ts';

import ModalMergeConflict from './modal-merge-conflict.vue';

const {
  activeMergeConflict,
} = useMergeConflictHost();
</script>
